<template>
  <li v-if="!Array.isArray(route.to)" class="nav-item" data-toggle="tooltip" data-placement="right">
    <router-link v-bind:to="route.to" class="nav-link" @click.native="clickLink">
      <i v-bind:class="route.meta.iconClass" style="position:relative;">
        <span v-if="route.name == 'guestbook' && allGuests > 0" class="badge bg-danger navbar-badge">
          {{ allGuests }}
        </span>
      </i>
      <span class="title">
        {{ $t(route.name) }}
      </span>
    </router-link>
  </li>
  <li v-else-if="route.to.length == 0" class="nav-item disabled" data-toggle="tooltip" data-placement="right" title="Nimate še nobene nastanitve">
    <a class="nav-link disabled">
      <i v-bind:class="route.meta.iconClass"></i>
      <span class="title">
        {{ $t(route.name) }}
      </span>
    </a>
  </li>
  <li v-else-if="route.to.length == 1" class="nav-item" data-toggle="tooltip" data-placement="right">
    <router-link v-bind:to="route.to[0].to" class="nav-link" @click.native="clickLink">
      <i v-bind:class="route.meta.iconClass" style="position:relative;">
        <span v-if="route.name == 'guestbook' && allGuests" class="badge bg-danger navbar-badge">
          {{ allGuests }}
        </span>
      </i>
      <span class="title">
        {{ $t(route.name) }}
      </span>
    </router-link>
  </li>
  <li v-else class="nav-item">
    <a href="javascript:void(0)" class="nav-link" data-toggle="collapse" aria-expanded="false">
      <i v-bind:class="route.meta.iconClass" style="position:relative;">
        <span v-if="route.name == 'guestbook' && allGuests > 0" class="badge bg-danger navbar-badge">
          {{ allGuests }}
        </span>
      </i>
      <span class="title">{{ $t(route.name) }}</span>
    </a>
    <ul class="collapse nav flex-column" :id="'collapse-' + route.name">
      <li v-for="r in route.to" class="nav-item">
        <router-link v-bind:to="r.to" class="nav-link" @click.native="clickLink">
          <i v-bind:class="r.meta.iconClass" style="position:relative;">
            <span v-if="route.name == 'guestbook' && $store.state.newGuests.find(n => n._id == r._id) && $store.state.newGuests.find(n => n._id == r._id).newGuests > 0" class="badge bg-danger navbar-badge">
              {{ $store.state.newGuests.find(n => n._id == r._id).newGuests }}
            </span>
            {{r.meta.iconContent}}
          </i>
          <span class="title">
            {{r.name}}
          </span>
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
  export default {
    name: 'NavigationLinks',
    props: [
      'route'
    ],
    methods: {
      clickLink: function(){
        if(window.matchMedia("(max-width: 450px)").matches){
          document.body.classList.toggle("show-sidenav");
          window.scrollTo(0, 0);
        }
      },
    },
    filters: {
      propertyGuest(val, propId){
        let property = val.find(a => a._id == propId);
        if(!property) return 0;
        return property.newGuests;
      }
    },
    computed: {
      allGuests(){
        if(!this.$store.state.newGuests.length) return 0;
        if(this.$store.state.newGuests.length == 1) return this.$store.state.newGuests[0].newGuests
        return this.$store.state.newGuests.reduce((a,b) => a.newGuests + b.newGuests)
      },
    },
  }
</script>

<style>
.navbar-badge{
  position: absolute;
  font-size:12px !important;
  padding:3px 5px !important;
  top:-8px;
  right:0;
}
</style>

<i18n>
{
  "en": {
    "calendar": "Calendar",
    "bookings": "Bookings for property",
    "guestbook": "Guestbook",
    "locks": "Locks",
    "invoices": "Invoices",
    "reports": "Reports",
    "settings": "Settings"
  },
  "sl": {
    "calendar": "Koledar",
    "bookings": "Rezervacije",
    "guestbook": "Knjiga gostov",
    "locks": "Ključavnice",
    "invoices": "Računi",
    "reports": "Poročila",
    "settings": "Nastavitve"
  }
}
</i18n>
